import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { UsersComponent } from './users.component';
import { UsersDetailsComponent } from './components/users-details/users-details.component';
import { UsersViewComponent } from './components/users-view/users-view.component';
import { UserCreateComponent } from './components/user-create/user-create.component';



const routes: Routes = [
  {
    path: '', component:UsersComponent,children:[
       {
         path:'',component: UsersDetailsComponent
       },
       {
        path:'details',component: UsersDetailsComponent
       },
       {
         path: 'view/:id', component: UsersViewComponent
       },
       {
         path: ':id',component:UserCreateComponent
       } 
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UsersRoutingModule { }